import { Component, OnInit } from '@angular/core';
import {MatBottomSheetRef} from '@angular/material';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { PostService } from'../../../services/firebase/firebase.service';


@Component({
  selector: 'action-delete-post',
  templateUrl: './delete-post.component.html',
  styleUrls: ['./delete-post.component.css']
})

export class DeletePostActions {

	constructor(private bottomSheetRef: MatBottomSheetRef<DeletePostActions>,
		private postService:PostService,
		private route: ActivatedRoute,
		private router: Router){}

	delete(): void {
		this.postService.removePost(this.bottomSheetRef.containerInstance.bottomSheetConfig.data.post_id);
		this.bottomSheetRef.dismiss();
		this.router.navigate(['/']);
	}
	cancel():void{
		this.bottomSheetRef.dismiss();
	}
}